import React, {useEffect, useState} from 'react';

export default function Timer({startTimeRef, running}){
  const [elapsedMs, setElapsedMs] = useState(0);

  useEffect(() => {
    if (!running || !startTimeRef?.current) {
      setElapsedMs(0);
      return;
    }
    // update every 200ms
    const update = () => {
      setElapsedMs(Date.now() - startTimeRef.current);
    };
    update();
    const id = setInterval(update, 200);
    return () => clearInterval(id);
  }, [running, startTimeRef]);

  const format = (ms) => {
    if (!ms) return '0.00s';
    const s = Math.floor(ms/1000);
    const msRem = Math.floor((ms % 1000)/10);
    return `${s}.${msRem.toString().padStart(2,'0')}s`;
  };

  return (
    <div className="timer">
      <span className="timer-label">Time:</span>
      <span className="timer-value">{format(elapsedMs)}</span>
    </div>
  );
}
